import { render, staticRenderFns } from "./SupplierNote.vue?vue&type=template&id=5536edec&scoped=true&"
import script from "./SupplierNote.vue?vue&type=script&lang=js&"
export * from "./SupplierNote.vue?vue&type=script&lang=js&"
import style0 from "./SupplierNote.vue?vue&type=style&index=0&id=5536edec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5536edec",
  null
  
)

export default component.exports